import { useEffect, useState } from 'react';
import { api, type VisaDocumentKind } from './api';
import { VisaDocumentPreview } from './VisaDocumentPreview';
import { VIZE_BELGELERI as M } from './metin/vize-belgeleri';

/** The card owns the blob URL; its modal borrows it without a second authenticated fetch. */
export function VisaInlinePreview({ requestId, documentId, kind, close }: { requestId: string; documentId: string; kind: VisaDocumentKind; close: () => void }) {
  const [resource, setResource] = useState<{ url: string; mime: string } | null>(null);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  const [large, setLarge] = useState(false);
  useEffect(() => {
    const controller = new AbortController(); let active = true; let url: string | null = null;
    setResource(null); setFailed(false); setLarge(false);
    void api.previewVisaDocument(requestId, documentId, controller.signal).then(blob => {
      if (!active) return;
      url = URL.createObjectURL(blob); setResource({ url, mime: blob.type });
    }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; controller.abort(); if (url) URL.revokeObjectURL(url); };
  }, [requestId, documentId, retry]);
  return <div className="visa-inline-preview" data-testid="visa-inline-preview">
    <div className="visa-document-actions"><button type="button" onClick={close}>{M.onizlemeKapat}</button>{resource && !failed ? <button type="button" onClick={() => setLarge(true)}>{M.buyukAc}</button> : null}</div>
    {!resource && !failed ? <p role="status">{M.onizlemeYukleniyor}</p> : null}
    {failed ? <div role="alert"><p>{M.onizlemeHatasi}</p><button type="button" onClick={() => setRetry(value => value + 1)}>{M.yeniden}</button></div> : null}
    {resource && !failed && resource.mime === 'application/pdf' ? <iframe title={M.onizleme} src={resource.url} data-testid="visa-inline-pdf" onError={() => setFailed(true)} /> : null}
    {resource && !failed && resource.mime !== 'application/pdf' ? <img alt={M.turler[kind]} src={resource.url} data-testid="visa-inline-image" onError={() => setFailed(true)} /> : null}
    {resource?.mime === 'application/pdf' ? <p>{M.pdfIndir}</p> : null}
    {large && resource && !failed ? <VisaDocumentPreview requestId={requestId} documentId={documentId} kind={kind} resource={resource} close={() => setLarge(false)} /> : null}
  </div>;
}
